import ApiService, { ApiArguments } from '@/api/api_service';
import {
  DefaultPromptSettingApi,
  GetDefaultPromptSettings200Response,
  DefaultPromptSettingApiPostDefaultPromptSettingsRequest,
} from '@/api/openapi';

export class DefaultPromptSettingService extends ApiService {
  api = new DefaultPromptSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getDefaultPromptSettings({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<GetDefaultPromptSettings200Response>(
      this.api.getDefaultPromptSettings(options),
      errorHandlers,
    );
  }

  async postDefaultPromptSettings({
    request,
    options,
    errorHandlers,
  }: ApiArguments<DefaultPromptSettingApiPostDefaultPromptSettingsRequest>) {
    return this.checkResponse<void>(
      this.api.postDefaultPromptSettings(request, options),
      errorHandlers,
    );
  }
}
